module.exports = __webpack_public_path__ + "img/Mockups 1.467b157e.png";